// CAD Sheet types, constants, and calculation functions

export const STONE_CATEGORIES = ['Center Stone', 'Accent Stone'];

export const JEWELRY_TYPES = ['Ring', 'Necklace', 'Pendant', 'Earring', 'Bangle', 'Bracelet', 'Chain', 'Other'];
export const METAL_KARATS = ['9K', '10K', '14K', '18K', '22K', '24K', 'Electrum', 'Platinum', 'Silver', 'Brass'];
export const METAL_COLORS = ['White', 'Yellow', 'Rose', 'S925', 'Pt950', 'Pt900', 'Brass'];
export const STONE_TYPES = ['Diamond', 'CVD', 'Colour Stone', 'Other'];
export const FINISHING_TYPES = ['High Polish', 'Matte', 'Satin', 'Brushed', 'Hammered', 'Sandblasted', 'Other'];
export const DEFAULT_LABELS = ['Front View', 'Top View', 'Side View', 'Perspective View'];

export const FINDINGS_BY_TYPE = {
  Ring: [],
  Necklace: ['Chain', 'Clasp', 'Spring Ring'],
  Pendant: ['Bail', 'Chain'],
  Earring: ['Post', 'Butterfly', 'Lever Back', 'Hook', 'Clip-on'],
  Bangle: ['Hinge', 'Clasp'],
  Bracelet: ['Chain', 'Clasp', 'Lobster Claw', 'Toggle'],
  Chain: ['Clasp', 'Spring Ring', 'Lobster Claw'],
  Other: [],
};

export const DEFAULT_ANNOTATION_STYLE = {
  lineColor: '#000000',
  lineWidth: 0.4,
  fontSize: 2.8,
  textColor: '#000000',
};

export const DEFAULT_TEXTBOX_STYLE = {
  bold: true,
  fontSize: 2.8,
  color: '#000000',
};

export function calcTotalMetalWeight(metals) {
  return metals.reduce((sum, m) => {
    const w = parseFloat(m.netWeight);
    return sum + (isNaN(w) ? 0 : w);
  }, 0);
}

export function calcTotalStoneWeight(stones) {
  return stones.reduce((sum, s) => {
    const w = parseFloat(s.weight_per_stone ?? s.weight);
    const q = parseInt(s.quantity) || 1;
    return sum + (isNaN(w) ? 0 : w * q);
  }, 0);
}

export function calcGrossWeight(metals, stones) {
  const totalMetal = calcTotalMetalWeight(metals);
  if (totalMetal === 0) return '';
  const totalCt = calcTotalStoneWeight(stones);
  return (totalMetal + totalCt / 5).toFixed(2);
}

export function createEmptySheet() {
  return {
    styleNo: '',
    jewelryType: 'Ring',
    customerName: '',
    customerDesignNo: '',
    metals: [{ id: crypto.randomUUID(), karat: '14K', color: 'Yellow', netWeight: '' }],
    netWeight: '',
    grossWeight: '',
    grossWeightManual: false,
    size: '',
    date: new Date().toISOString().split('T')[0],
    designerName: '',
    stones: [],
    findings: [],
    otherDetails: '',
    images: DEFAULT_LABELS.map((label, i) => ({
      id: i,
      file: null,
      url: '',
      label,
      annotations: [],
      textBoxes: [],
      highlights: [],
    })),
    finishing: '',
    engravingInstructions: '',
    engravingImage: null,
    customerImages: [],
  };
}
